<template>
    <div class="content-wrapper definitions">
        <div v-for="type in orgTypes" :key="type">
            <div v-if="type === 'provider' || type === 'supplier'">
                <h3>Definitions - {{ type === 'provider' ? 'Provider' : 'Supplier' }}</h3>
                <p v-for="(value, status) in statuses[type]" :key="status" class="display-flex">
                    <strong class="display-inline-flex flex-shrink-0">
                        <engagement-icon :engagement="status" class="engagement-icon"></engagement-icon>
                        <span :class="getColorClass(status)">{{value.title}}</span>
                    </strong>
                    <span>{{value.definition}}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
    // import { ref } from 'vue'
    import EngagementIcon from './EngagementIcon.vue'
    import {getColorClass} from '../reusables/GetColorClass.js'

    let props = defineProps({
        orgTypes: Array
    })
    // const sortOrder = ['engaged', 'supplier', 'sponsor', 'partner', 'collaborator'];
    const unifiedStatuses = {"adopted": {"title": "Adopted","definition": "I have deployed the HIRC standard in my business operations. Badges: I ask suppliers if they have each badge and value if yes."},"engaged": {"title": "Engaged","definition": " I support the HIRC standard and intend to adopt within 12 months."},"acknowledged": {"title": "Acknowledged","definition": "I have received the request to consider adoption of the HIRC standard."},"unresponsive": {"title": "Unresponsive","definition": "I have not responded to whether I will adopt or decline the HIRC standard."},"declined": {"title": "Declined","definition": " I decline the HIRC standard.  I do not wish to align with this specific industry expectation."}}
    const statuses = {"supplier": unifiedStatuses, "provider": unifiedStatuses}

</script>
<style scoped>
    .engagement-icon {
        flex: 0 0 24px;
    }
    .definitions strong {
        flex: 0 0 170px;
    }
    .has-gray-light-color {
        color: #7F7F7F;
    }
</style>